/* Coaching Systems - Shopify contact forms (quote / contact / demo / form pages / OSHA).
 * - Conditional fields: [data-show-when="Field Name=Value A|Value B ; Other Field=Yes"]
 *   (all conditions must match; values are OR'ed). Hidden fields are disabled so
 *   they are neither validated nor submitted.
 * - Client-side required/email validation with Gravity-Forms style messages.
 */
(function () {
  'use strict';

  var MSG_REQUIRED = 'Please complete this required field.';
  var MSG_EMAIL = 'Email must be formatted correctly.';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function fieldValue(form, key) {
    var wrap = form.querySelector('[data-cs-field="' + key.replace(/"/g, '\\"') + '"]');
    if (!wrap || wrap.hidden) return '';
    var el = wrap.querySelector('select, textarea, input:not([type="hidden"])');
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked ? 'Yes' : 'No';
    return (el.value || '').trim();
  }

  function parseConditions(str) {
    return str.split(';').map(function (part) {
      var i = part.indexOf('=');
      if (i < 0) return null;
      return {
        key: part.slice(0, i).trim(),
        values: part.slice(i + 1).split('|').map(function (v) { return v.trim(); })
      };
    }).filter(Boolean);
  }

  function evaluate(form) {
    // Run twice so chained conditions settle.
    for (var pass = 0; pass < 2; pass++) {
      form.querySelectorAll('[data-show-when]').forEach(function (el) {
        var conds = parseConditions(el.getAttribute('data-show-when'));
        var show = conds.every(function (c) { return c.values.indexOf(fieldValue(form, c.key)) !== -1; });
        el.hidden = !show;
        el.querySelectorAll('input, select, textarea').forEach(function (input) { input.disabled = !show; });
      });
    }
  }

  function clearError(wrap) {
    wrap.classList.remove('gfield_error');
    var m = wrap.querySelector('.validation_message');
    if (m) m.remove();
  }

  function setError(wrap, msg) {
    wrap.classList.add('gfield_error');
    if (!wrap.querySelector('.validation_message')) {
      var d = document.createElement('div');
      d.className = 'gfield_description validation_message';
      d.textContent = msg;
      wrap.appendChild(d);
    }
  }

  function validate(form) {
    var firstBad = null;
    form.querySelectorAll('[data-cs-field]').forEach(function (wrap) {
      clearError(wrap);
      if (wrap.hidden) return;
      var el = wrap.querySelector('select, textarea, input:not([type="hidden"])');
      if (!el || el.disabled) return;
      var val = el.type === 'checkbox' ? (el.checked ? 'x' : '') : (el.value || '').trim();
      var msg = null;
      if (el.required && !val) msg = MSG_REQUIRED;
      else if (val && el.type === 'email' && !EMAIL_RE.test(val)) msg = MSG_EMAIL;
      else if (val && el.type === 'number' && el.min !== '' && parseFloat(val) < parseFloat(el.min)) {
        msg = 'Please enter a number greater than or equal to ' + el.min + '.';
      }
      if (msg) {
        setError(wrap, msg);
        if (!firstBad) firstBad = el;
      }
    });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }

  function init(root) {
    var form = root.querySelector('form');
    if (!form || form.dataset.csFormReady) return;
    form.dataset.csFormReady = '1';
    evaluate(form);
    form.addEventListener('change', function () { evaluate(form); });
    form.addEventListener('input', function (e) {
      var wrap = e.target.closest('[data-cs-field]');
      if (wrap) clearError(wrap);
    });
    form.addEventListener('submit', function (e) {
      evaluate(form);
      if (!validate(form)) e.preventDefault();
    });
    var success = root.querySelector('[data-cs-form-success]');
    if (success) {
      var redirect = success.getAttribute('data-redirect');
      if (redirect) {
        window.location.href = redirect;
        return;
      }
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function boot() {
    document.querySelectorAll('[data-cs-form]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
